{
  "title": "Siden finnes ikke",
  "notFound": "siden du ser etter eksisterer ikke",
  "goHome": "gå tilbake til forsiden"
}
